const _ = require("lodash");
const {V} = require("./VectorDraw");
const ColorUtil = require("../../util/ColorUtil");
const Common = require("./CommonHelpers");
const D = Common.D;
const cs = ColorUtil.getCurrentScheme();
const colors = ColorUtil.getDiagramColors();

// Set of functions RR wrote back when we first had diagrams

module.exports = {
	dot: function(ctx, x, y, options = {}) {
		const settings = _.extend(
			{
				fillStyle: cs.defaultText,
				radius: 5,
			},
			options
		);

		const originalFill = ctx.fillStyle;

		ctx.beginPath();
		ctx.arc(x, y, settings.radius, 0, 2 * Math.PI, false);
		ctx.fillStyle = settings.fillStyle;
		ctx.fill();

		ctx.fillStyle = originalFill;
	},

	gumball: function(ctx, x, y, options = {}) {
		const settings = _.extend(
			{
				fillStyle: colors.pink,
				radius: 5,
			},
			options
		);

		const originalFill = ctx.fillStyle;

		this.dot(ctx, x, y, {
			fillStyle: settings.fillStyle,
			radius: settings.radius,
		});

		ctx.fillStyle = originalFill;
	},

	//Move array of points by nudge_x, nudge_y
	applyNudge: function(p, nudge_x, nudge_y) {
		const len = p.length;
		for (let i = 0; i < len; i++) {
			p[i] = p[i].add(nudge_x, nudge_y);
		}
	},

	//Scale array of points, then apply nudge
	nudgeAndScale: function(arr, nudge_x, nudge_y, scale) {
		const result = this.arrayToVectors(arr, scale);
		this.applyNudge(result, nudge_x, nudge_y);
		return result;
	},

	labelrect: function(ctx, w, h, settings) {
		settings = _.extend(
			{
				labelSpace: 25,
			},
			settings
		);
		const n = 4;

		let x = n;
		let y = n;
		ctx.setSize(
			settings.labelSpace + 2 * n + w,
			settings.labelSpace + 2 * n + h
		);
		if (settings.sides[0].length > 0) {
			y += settings.labelSpace;
		}
		if (settings.sides[3].length > 0) {
			x += settings.labelSpace;
		}
		this.rect(ctx, x, y, w, h, settings);
	},

	regularPolyByR: function(ctx, x, y, n, r, options = {}) {
		const settings = _.extend(
			{
				fillStyle: cs.lightGrayFill,
				hasFill: false,
				lineWidth: 1,
				rot: 0,
			},
			options
		);
		const center = V(x, y);
		const vertices = [];

		let angle = settings.rot;

		for (let i = 0; i < n; i++) {
			angle += 360 / n;
			vertices[i] = center.polarAdd(r, angle);
		}
		this.drawPoly(ctx, vertices, {
			hasFill: settings.hasFill,
			fillStyle: settings.fillStyle,
			lineWidth: settings.lineWidth,
		});
	},

	//Turns array of vertices as arrays into array of vectors with given scale
	arrayToVectors: function(vertices, scale) {
		const result = [];
		_.each(vertices, function(vertex) {
			result.push(V(vertex[0] * scale, vertex[1] * scale));
		});
		return result;
	},

	drawPoly: function(ctx, vertices, options = {}) {
		const settings = _.extend(
			{
				strokeStyle: cs.defaultText,
				lineWidth: 1,
				fillStyle: cs.lightGrayFill,
				hasFill: false,
				hasStroke: true,
				textStyle: cs.defaultText,
			},
			options
		);
		ctx.save();
		ctx.lineWidth = settings.lineWidth;
		ctx.fillStyle = settings.fillStyle;
		ctx.textStyle = settings.textStyle;
		ctx.bp();
		ctx.M(vertices[0]);
		for (let i = 1; i < vertices.length; i++) {
			ctx.L(vertices[i]);
		}
		ctx.Z();
		if (settings.hasFill) {
			ctx.fill();
		}

		if (settings.hasStroke) {
			ctx.stroke();
		}
		ctx.restore();
	},

	//Constructs vertices of a regular polygon with n sides, center Vector c,
	constructRegularPolygonVertices: function(n, c, r, delta) {
		const vertices = [];
		for (let i = 0; i < n; i++) {
			vertices[i] = c.polarAdd(r, (360 * i) / n + delta);
		}
		return vertices;
	},

	outputDistance: function(v1, v2, scale) {
		Common.log(
			Math.sqrt(Math.pow(v1[0] - v2[0], 2) + Math.pow(v1[1] - v2[1], 2)) / scale
		);
	},

	// Draw |-----batex-----|
	// Supports horizontal and vertical
	labeledMeasure: function(ctx, v1, v2, batex, ticklen) {
		const vec = V.add(v1, V.neg(v2));
		const len = vec.magnitude();
		if (len === 0) {
			return;
		}
		ctx.bp();
		const uptick = vec.rotateDeg(90).scale(ticklen / len);
		const downtick = vec.rotateDeg(90).scale(-ticklen / len);
		ctx
			.M(v1.add(uptick))
			.L(v1.add(downtick))
			.stroke();
		ctx
			.M(v2.add(uptick))
			.L(v2.add(downtick))
			.stroke();
		if (batex.length > 0) {
			const midpoint = V.mid(v1, v2);
			const lRect = midpoint.label(ctx, batex, V(0, 0));
			let lStart = midpoint.sub(lRect[2] * 0.6, 0);
			let lEnd = midpoint.add(lRect[2] * 0.6, 0);
			if (v1[0] === v2[0]) {
				lStart = midpoint.sub(0, lRect[3] * 0.6);
				lEnd = midpoint.add(0, lRect[3] * 0.6);
			}
			ctx
				.M(v1)
				.L(lStart)
				.stroke();
			ctx
				.M(v2)
				.L(lEnd)
				.stroke();
		} else {
			ctx
				.M(v1)
				.L(v2)
				.stroke();
		}
	},

	rect: function(ctx, x, y, w, h, options = {}) {
		const settings = _.extend(
			{
				strokeStyle: cs.defaultText,
				lineWidth: 1,
				outerLineWidth: 1,
				fillStyle: cs.lightGrayFill,
				hasFill: false,
				hasStroke: true,
				textStyle: cs.defaultText,
				corners: [],
				sides: [], // top, right, bottom, left
				centeredText: false,
				centered: false,
				hasGrid: false,
				nGridH: 0,
				nGridV: 0,
				gridStyle: cs.inactiveFill,
			},
			options
		);

		ctx.save();
		ctx.lineWidth = settings.lineWidth;
		ctx.strokeStyle = settings.strokeStyle;
		ctx.fillStyle = settings.fillStyle;

		ctx.bp();
		ctx.rect(x, y, w, h);

		if (settings.hasFill) {
			ctx.fill();
		}

		if (settings.hasGrid) {
			const gridXStep = w / (settings.nGridV + 1);
			const gridYStep = h / (settings.nGridH + 1);
			ctx.bp();
			ctx.strokeStyle = settings.gridStyle;
			let i;
			for (i = 1; i <= settings.nGridH; i++) {
				ctx.M(x, y + i * gridYStep).L(x + w, y + i * gridYStep);
			}
			for (i = 1; i <= settings.nGridV; i++) {
				ctx.M(x + i * gridXStep, y).L(x + i * gridXStep, y + h);
			}
			ctx.stroke();
		}
		ctx.strokeStyle = settings.strokeStyle;
		ctx.bp();
		ctx.rect(x, y, w, h);

		if (settings.hasStroke) {
			ctx.lineWidth = settings.outerLineWidth;
			ctx.stroke();
		}

		/** set FillStyle to whatever the text color is **/

		/** Add Labels Here **/
		if (settings.sides.length === 4) {
			ctx.fillStyle = settings.textStyle;
			if (settings.sides[0].length > 0) {
				Common.label(ctx, settings.sides[0], x + w / 2, y, D.N);
			}
			if (settings.sides[1].length > 0) {
				Common.label(ctx, settings.sides[1], x + w, y + h / 2, D.E);
			}
			if (settings.sides[2].length > 0) {
				Common.label(ctx, settings.sides[2], x + w / 2, y + h, D.S);
			}
			if (settings.sides[3].length > 0) {
				Common.label(ctx, settings.sides[3], x, y + h / 2, D.W);
			}
		}
		if (settings.centeredText && settings.centeredText.length > 0) {
			ctx.fillStyle = settings.textStyle;
			Common.label(ctx, settings.centeredText, x + w / 2, y + h / 2, [0, 0]);
		}

		ctx.restore();
	},
};
